(function () {
  // If listeners have already been attached, exit the IIFE.
  if (window.popTrigListenersAdded) return;
  window.popTrigListenersAdded = true;

  let activeImg = null;

  function handlePopTrigger(event) {
      if (event.target.classList.contains('js-pop-trig')) {
          const action = event.target.getAttribute('data-action');
          const popImg = event.target.nextElementSibling;

          if (action === 'open' && popImg) {
              activeImg = popImg;
              activeImg.classList.add('is-active');
          }
          if (action === 'close' && activeImg) {
              activeImg.classList.remove('is-active');
              activeImg = null;
          }
      }
  }

  const body = document.querySelector('.shop-all-redesign');
  if (body) {
      body.addEventListener('click', (event) => {
          if (activeImg) {
              const nutritionImage = activeImg.querySelector('.nutritionImage');
              const isClickOutside = !nutritionImage.contains(event.target);

              if (isClickOutside) {
                  activeImg.classList.remove('is-active');
                  activeImg = null;
              }
          }
      });
  }

  document.addEventListener('click', handlePopTrigger);
})();